import { API } from '@/config';
import {
  FILL_LIST,
} from './mutations-types';

export default {
  async getList({ commit }, project) {
    try {
      const params = {
        project,
      };
      const { records, total } = (await API.get('project/alternativeMenu/getList', { params })).data.data;
      commit(FILL_LIST, { records, total });
    } catch (e) {
      console.log(e);
    }
  },

  async getAllList({ commit }) {
    try {
      const { records, total } = (await API.get('project/alternativeMenu/getAllList')).data.data;
      commit(FILL_LIST, { records, total });
    } catch (e) {
      console.log(e);
    }
  },
};
